import constants from "../../constants";
import { useLocation } from "react-router-dom";
import useAxiosPrivate from "../useAxiosPrivate";
import { useContext, useRef, useState } from "react";
import AlertContext from "../../context/AlertContext";
import { getMinutesGap, getDataFromStorage } from "../../util";
import useCommonFunctionHooks from "../useCommonFunctionHooks";
import moment from "moment";

export default function MenuBarHooks() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const isPreviewLp = new URLSearchParams(window.location.search).get("mode") === "previewlp";

  const { pathname } = useLocation();

  const activeBatchRef = useRef(null);

  const [feature, setFeature] = useState(false);
  const [cachedTime, setCachedTime] = useState(
    moment().format("YYYY-MM-DD HH:mm:ss")
  ); // for leaderboard

  const handleSetLocalStorage = (batch) => {
    localStorage.setItem("batchid", batch.id);
    localStorage.setItem("batchType", batch.type);
    localStorage.setItem("batchname", batch.name);
  };

  const handleCompany = () => {
    if(isPreviewLp) return 
    Alert.setDashBoardDetails([]);
    localStorage.removeItem("batchid");
    localStorage.removeItem("hideBatch");
    localStorage.removeItem("batchType");
    localStorage.removeItem("batchname");
    localStorage.removeItem("companyId");
    Alert.navigate("/company");
  };

  const handleLeaderBoard = (refresh = false) => {
    Alert.setLoadingLeaderboard(true);
    Alert.setLeaderBoardData([]);

    axios
      .get(
        `node/learner/${getDataFromStorage(
          "learnerid"
        )}/batch/${localStorage.getItem(
          "batchid"
        )}/leaderboard?refresh=${refresh}`,
        useCommonFunctionHks.getHeaderDetailsForAxios()
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR) {
          Alert.setLoadingLeaderboard(false);
        } else {
          if (res.data.resultCode === constants.RESULT_STATUS.NO_DATA) {
            Alert.setLoadingLeaderboard(false);
          } else {
            Alert.setLeaderBoardData(res.data.data.data);
            setCachedTime(
              moment(Number(res.data.createdAt)).format("YYYY-MM-DD HH:mm:ss")
            );
            Alert.setLoadingLeaderboard(false);
          }
        }
      })
      .catch((error) => {
        Alert.setLoadingLeaderboard(false);
      })
      .finally(() => Alert.setIsLoaded(false));
  };

  const handleBatch = (batch) => {
    handleSetLocalStorage(batch);

    if (!pathname.includes("testresults") && !pathname.includes("timespent")) {
      Alert.setDashBoardDetails([]);
      handleDashBoard();
      Alert.navigate("/main/dashboard");
    } else {
      Alert.navigate(pathname);
    }
  };

  const handleDashBoard = (SOADashboard) => {
    let isSOADashboard = SOADashboard ?? false;
    if (
      parseInt(localStorage.getItem("batchType")) !==
        constants.BATCH_TYPE.TESTING &&
      !isSOADashboard
    ) {
      handleLeaderBoard();
    }

    Alert.setIsLoaded(true);
    axios
      .post(
        "node/learner/dashboard",
        JSON.stringify({
          batchId: localStorage.getItem("batchid"),
          learnerId: getDataFromStorage("learnerid"),
          isSOADashboard: isSOADashboard,
          companyId: localStorage.getItem("companyId"),
        }),
        useCommonFunctionHks.getHeaderDetailsForAxios()
      )
      .then((res) => {
        if (res.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR) {
          Alert.setShowNotify({
            show: true,
            title: "Info",
            msg: res.data.msg,
          });
        } else {
          if (res.data.resultCode === constants.RESULT_STATUS.NO_DATA) {
            Alert.setShowNotify({
              show: true,
              title: "Info",
              msg: "Learningpath is not published",
            });
          } else {
            Alert.setDashBoardDetails(res.data.data);

            const givenTime = res.data.data.attendanceExpiry;
            const minutesGap = getMinutesGap(givenTime);

            let mss = minutesGap * 60 * 1000;

            if (Alert.showBlink && !res.data.data.markAttendance) {
              Alert.setShowBlink(res.data.data.markAttendance);
            }

            if (
              !Alert.showBlink &&
              res.data.data.markAttendance &&
              minutesGap >= 0
            ) {
              Alert.setShowBlink(res.data.data.markAttendance);
              setTimeout(() => {
                document
                  .getElementById("svg-element")
                  .classList.remove("blinking");
                Alert.setShowBlink(false);
              }, [mss]);
            }

            if (
              res.data.data.lpData?.length === 1 &&
              res.data.data.batchDetails?.length === 1 &&
              parseInt(localStorage.getItem("batchType")) ===
                constants.BATCH_TYPE.TESTING
            ) {
              sessionStorage.setItem("lpId", res.data.data.lpData[0]?.lpId);
              Alert.setLpId(res.data.data.lpData[0]?.lpId);
              // Alert.navigate("/home");
            }
          }
        }
      })
      .catch((error) => {
        useCommonFunctionHks.getCatchBlockDetails(error);
      })
      .finally(() => Alert.setIsLoaded(false));
  };

  return {
    feature,
    setFeature,
    handleBatch,
    handleCompany,
    activeBatchRef,
    handleDashBoard,
    handleSetLocalStorage,
    handleLeaderBoard,
    cachedTime,
  };
}
